import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { VALUE_ESCAPE } from '@wizeoo/akm-core-lib';
import { WizAgGrid, WizBasePopUp, WizDatasource } from '@wizeoo/akm-component-lib';
import { WizColDef } from '../../manager/workingdata/fei.engine';
import { KeyPair } from '@wizeoo/akm-compute-lib';
import { ColDef } from 'ag-grid-community';
import { Model } from '../../model/model';

// popUp d'affichage des erreurs lors d'un drop Excel
@Component({
  selector: 'excel-error-pop',
  templateUrl: './excel-error.pop.html',
})
export class ExcelErrorPop extends WizBasePopUp implements AfterViewInit {
  @ViewChild('agGrid') agGrid: WizAgGrid<KeyPair>;

  // validation sur enter, sortie sur Esc
  @HostListener('window:keydown', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.key === VALUE_ESCAPE) {
      this.hide();
    }
  }

  public static width: string = '600px';
  public static height: string = '350px';
  
  columns: ColDef[]; // Colonnes du grid


  public model: Model = null;

  /** demande d'export depuis le bouton */
  public exportDatas(): void {
    this.model.excelExportEngine.exportError(this.mainDS.getSource());
  }

  /** la DS */
  public mainDS: WizDatasource<KeyPair> = new WizDatasource<KeyPair>([]).build();

  constructor(public elementRef: ElementRef, protected cdref: ChangeDetectorRef) {
    super();
  }

  show(): void { 
    
    this.model = this.datas[0];

    this.columns = [];
    let col: WizColDef;

    col = { headerName: '$.excel.import.row.$',
    field: 's',
    sortable: false,
    resizable: false,
    width: 100}
    this.columns.push(col);

    col = { headerName: '$.excel.import.error.$',
    field: 'l',
    sortable: true,
    resizable: false,
    flex: 1,
    tooltipField: 'l'};
    this.columns.push(col);

    this.mainDS.setSource(this.datas[1]);
  }


  /** fermeture */
  public doCancel(): void {
    this.hide();
  }

}
